<template>
  <div>
    <Modal width="830" v-model="isShow" :mask-closable="false"
           @on-ok="ok" :loading="loading" @on-cancel="cancel"
           ok-text="费用结算预览"
           class=" long-modal"
    >
      <h3 slot="header" class="modal-header">合同解约</h3>
      <div class="specialdrop " style="padding: 0 10px;">

        <div style="line-height: 4;padding: 30px 20px 0 20px " v-if="data" class="mb15form">
          <Form :label-width="120" ref="formData" :rules="formRules" :model="data" label-position="left">
            <FormItem label="解约类型" prop="">
              <span>{{data.surTypeName}}</span>
            </FormItem>
            <FormItem label="解约申请日期">
              <span>{{formatDateTime(data.surApplicationDate,false)}}</span>
            </FormItem>
            <FormItem label="合同租期">
              <span>{{formatDateTime(data.conStartDate,false)}}</span>至
              <span>{{formatDateTime(data.conEndDate,false)}}</span>
            </FormItem>
            <FormItem label="实际租期" prop="">
              <span>{{formatDateTime(data.conStartDate,false)}}</span>至
              <span>{{formatDateTime(data.surRentPriceDate,false)}}</span>
            </FormItem>
            <FormItem label="退租后房态" prop="stockStatus" class="notip">
              <Select class="width250" v-model="data.stockStatus">
                <Option value="">请选择</Option>
                <Option v-for="(item,index) in list1" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
              </Select>
            </FormItem>
            <FormItem label="可出租日期" prop="stockRentDate">
              <DatePicker class="width250" :disabled="disabledRentDate" v-model="stockRentDate" type="date" :options="stockRentDateOption" placeholder="请选择日期"></DatePicker>
            </FormItem>
            <FormItem label="解约原因类型" prop="surReasonType" class="notip">
              <Select class="width250" v-model="data.surReasonType">
                <Option value="">请选择</Option>
                <Option v-for="(item,index) in data.surReasons" :value="item.value" :key="'keyG'+index">{{item.text}}</Option>
              </Select>
            </FormItem>
            <FormItem label="解约原因" prop="surReason" class="notip" v-if="data.surReasonType==='其他原因'">
              <Input class="width250" v-model="data.surReason"/>
            </FormItem>

            <FormItem label="换租合同信息" prop="changeContractCode" class="notip" v-if="data.surType===4||data.surType===11||data.surType===12||data.surType===13||data.surType===14">
              <Input placeholder="新签合同号" class="width250" v-model="data.changeContractCode"/>
            </FormItem>
            <div v-if="data.surType===5">
              <FormItem label="转租人姓名" prop="subletCustomerName" class="notip">
                <Input class="width250" v-model="data.subletCustomerName"/>
              </FormItem>
              <FormItem label="转租人证件类型" prop="subletCardType" class="notip">
                <Select placeholder="" v-model="data.subletCardType" class="width250">
                  <Option value="">请选择</Option>
                  <Option v-for="(item,index) in list2" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem  prop="subletCustomerCertNum" label="转租人证件号" class="notip">
                <Input class="width250" placeholder="" v-model="data.subletCustomerCertNum">
                </Input>
              </FormItem>
              <FormItem label="转租人电话" prop="subletCustomerPhone" class="notip">
                <Input placeholder="" class="width250" v-model="data.subletCustomerPhone"/>
              </FormItem>
            </div>
          </Form>
        </div>
        <div>
          <h4 style="margin-top: 30px">生活费用信息</h4>
          <!--<Table :columns="columns1" :data="data1" class="mb26"></Table>-->
          <div>
            <Row class="row">
              <Col span="2">项目类别</Col>
              <Col span="2">是否智能</Col>
              <Col span="3">付费模式</Col>
              <Col span="3">上次示数</Col>
              <Col span="3">本次示数</Col>
              <Col span="2">单价</Col>
              <Col span="3">应退费用</Col>
              <Col span="3">附件</Col>
              <Col span="3">修改附件</Col>
            </Row>
            <Row class="row notip" v-for="(item,index) in data1Copy" :key="'keyN'+index">
              <Form :model="item" :inline="true" :rules="formRules1" :ref="'form1'+index">
                <Col span="2">{{item.meterTypeName ||'-' }}</Col>
                <Col span="2">{{item.isSmartDevice===true?'是':'否'}}</Col>
                <Col span="3">
                  <!--//付费模式  欢乐谷支持修改-->
                  <div v-if="item.allowModify">

                    <FormItem prop="meterPayType" class="notip">
                      <Select v-model="item.meterPayType">
                        <!--<Option value="">请选择</Option>-->
                        <Option v-for="(item,index) in payTypeList" :value="item.value" :key="'keyM'+index">
                          {{item.text}}
                        </Option>
                      </Select>
                    </FormItem>
                  </div>
                  <div v-else>{{item.meterPayType===0?'预付费':(item.meterPayType===1?'后付费':'-')}}</div>
                </Col>
                <Col span="3">
                  <!--上次示数-->
                  <div v-if="item.preMeterEdit===1">{{ item.preMeterDisplay?item.preMeterDisplay:(item.preMeterDisplay===0?0:'-')}}</div>
                  <div v-else>
                    <FormItem  prop="preMeterDisplay" class="notip">
                      <InputNumber class="inputwidth" v-model="item.preMeterDisplay" @on-change="getMeterAmount(item)"/>
                    </FormItem>
                  </div>

                </Col>
                <Col span="3">
                  <!--本次示数-->
                  <div v-if="item.curMeterEdit===1">{{item.curMeterDisplay?item.curMeterDisplay:(item.curMeterDisplay===0?0:'-')}}</div>
                  <div v-else>
                    <FormItem  prop="curMeterDisplay" class="notip">
                      <InputNumber class="inputwidth" v-model="item.curMeterDisplay" @on-change="getMeterAmount(item)"/>
                    </FormItem>
                  </div>
                </Col>
                <Col span="2">{{item.unitPrice||0}}</Col>
                <Col span="3">
                  <FormItem prop="meterAmount" class="notip">
                    <Input class="inputwidth" v-model="item.meterAmount" disabled/>
                  </FormItem>
                </Col>
                <Col span="3">
                  <!--附件-->
                  <a v-if="item.meterPic" href="javascript:;" @click.stop="showImg(item.meterPic)">{{item.meterPicName}}</a>
                  <span v-else>无</span>
                </Col>
                <Col span="3">
                  <!--修改附件-->
                  <div v-if="item.curMeterEdit===1">不支持修改</div>
                  <div v-else>
                    <Upload style="display: inline-block;margin-left: 5px"
                            :action="baseUrl+'/file/uploadFile'"
                            :data="{type:index}"
                            :on-success="handleSuccess"
                            :headers="{'Access-Token':token}"
                            :show-upload-list="false"
                            :on-error="handleError"
                            :format="['jpg','jpeg','png']"
                            :on-format-error="formatError"
                    >
                      <a v-if="item.meterPic" href="javascript:;">修改</a>
                      <a v-if="!item.meterPic" href="javascript:;">上传(必传)</a>
                    </Upload>
                  </div>
                </Col>
              </Form>
            </Row>
          </div>
        </div>
        <div class="mt36">
          <div class=" ">
            <h4 style="display: inline-block">房间物品信息</h4>
            <span style="color: red;float: right">物品信息如有缺误，请移步资产管理添加。</span>
          </div>
          <div class="">
            <Row class="row">
              <Col span="4">物品</Col>
              <Col span="4">大类</Col>
              <Col span="4">数量</Col>
              <Col span="4">价格</Col>
              <Col span="4">状态</Col>
              <Col span="4">赔付费用</Col>
            </Row>
            <Row class="row" v-for="(item,index) in data2" :key="'keyX'+index">
              <Form :model="item" :inline="true" :rules="formRules2" :ref="'form2'+index">
                <Col span="4">{{item.goodsName || '-'}}</Col>
                <Col span="4">{{item.goodsType ||'-' }} </Col>
                <Col span="4">{{item.goodsCount?item.goodsCount:(item.goodsCount===0?0:'-')}}</Col>
                <Col span="4">{{item.goodsPrice?item.goodsPrice:(item.goodsPrice===0?0:'-')}}</Col>
                <Col span="4">{{item.goodsStatusName || '-'}}</Col>
                <Col span="4">
                  <FormItem class="notip" prop="goodsPayAmount">
                    <Input class="inputwidth" v-model="item.goodsPayAmount"/>
                  </FormItem>
                </Col>
              </Form>
            </Row>
          </div>
        </div>
        <!--<Table :columns="columns2" :data="data2" class="mb26"></Table>-->
        <div class="mt36" style="margin-bottom: 50px">
          <h4>房间装修信息</h4>
          <div>
            <Row class="row">
              <Col span="5">装修项目</Col>
              <Col span="4">新旧</Col>
              <Col span="4">面积</Col>
              <Col span="4">状态</Col>
              <Col span="4">赔付费用</Col>
            </Row>
            <Row class="row" v-for="(item,index) in data3" :key="'keyW'+index">
              <Form :model="item" :inline="true" :rules="formRules3" :ref="'form3'+index">
                <Col span="5">{{item.goodsName}}</Col>
                <Col span="4">
                  <!--新旧-->
                  <FormItem class="notip" prop="goodsNewOld">
                    <Select class="inputwidth" v-model="item.goodsNewOld">
                      <!--<Option></Option>-->
                      <Option v-for="(item,index) in list3" :value="item.value"
                              :key="'keyY'+index">{{item.text}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="4">
                  <!--面积-->
                  <FormItem class="notip" prop="unit">
                    <Input class="inputwidth" v-model="item.unit"/>
                  </FormItem>
                </Col>
                <Col span="4">
                  <!--状态-->
                  <FormItem class="notip" prop="goodsStatus">
                    <Select class="inputwidth" v-model="item.goodsStatus">
                      <!--<Option></Option>-->
                      <Option v-for="(item,index) in list4" :value="item.value"
                              :key="'keyF'+index">{{item.text}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="4">
                  <!--赔付费用-->
                  <FormItem class="notip" prop="goodsPayAmount">
                    <Input class="inputwidth" v-model="item.goodsPayAmount"/>
                  </FormItem>
                </Col>
              </Form>
            </Row>
          </div>
        </div>
      </div>
      <!--<Table :columns="columns3" :data="data3"></Table>-->
      <settle-preview :n="n1" :surrenderIds="data.surFid"
                      :parentData="data"
                      :contractFid="contractFid"
                      @done="closeModal"
                      v-if="data"
                      :surMode="surMode"
                      :surStatus="surStatus"
      ></settle-preview>
      <img-show :n="imgN" :src="imgSrc"></img-show>
    </Modal>
  </div>
</template>
<script>
  import SettlePreview from './SettlePreviewFromUpdate.vue'
  import {
    getPersonalSurrenderInitInfo,
    getPersonalSurrenderMeterDeliveryInitInfo,
    getSurrenderDecorationGoodsDeliveryInitInfo,
    getSurrenderGoodsDeliveryInitInfo,
    validChangeRentContract,
    surrenderdeliverysave,
  } from "../../../../api/contractList";
  import {deepClone} from "../../../../utils/format";
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";
  import {formatDateTime} from "../../../../utils/format";
  import {calSurrenderMeterDeliveryAmount} from "../../../../api/contractList";
  import ImgShow from 'components/ImgShow/index';
  import stockStatus from '../mixins/stockStatus';

  export default {
    mixins: [stockStatus],
    components: {
      SettlePreview,
      ImgShow
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      contractFid: {
        type: String,
        default: ""
      },
      stockFid: {
        type: String,
        default: ""
      },
      surMode:{
        type: Number,
        default: null
      },
      surStatus:{
        type:Number,
        default:null
      }
    },
    watch: {
      n() {
        this.cleanData()
        this.getPersonalSurrenderInitInfo()
        this.getPersonalSurrenderMeterDeliveryInitInfo()
        this.getSurrenderDecorationGoodsDeliveryInitInfo()
        this.getSurrenderGoodsDeliveryInitInfo()
        this.isShow = true
      }
    },
    data() {
      return {
        imgSrc:'',
        imgN:0,
        data: null,
        token: '',
        baseUrl: '',
        payTypeList: [{text: '预付费', value: 0}, {text: '后付费', value: 1}],
        // surType: '',
        // surApplicationDate: '',
        list1: [{text: '待租中', value: 0}, {text: '配置中', value: 3}],
        list2: [],  //{text: '身份证', value: 0}, {text: '港澳通行证', value: 1}
        list3: [{text: '新', value: 0}, {text: '旧', value: 1}],
        list4: [{text: '正常', value: 0}, {text: '损坏', value: 1}],
        formRules: {
          changeContractCode: [
            {required: true, message: '请输入新签合同号', trigger: 'blur', type: 'string'}
          ],
          subletCustomerName: [
            {required: true, message: '请输入转租人姓名', trigger: 'blur', type: 'string'}
          ],
          subletCustomerCertNum: [
            {required: true, message: '请输入转租人身份证号', trigger: 'blur', type: 'string'}
          ],
          subletCustomerPhone: [
            {required: true, message: '输入正确的手机号', trigger: 'blur', validator: this.validatecontactPhone2}
          ],
          subletCardType: [
            {required: true, message: '请选择转租人证件类型', trigger: 'change', validator: this.validateNumber}
          ],
          stockStatus: [
            {required: true, message: '请选择退租后房态', trigger: 'change', validator: this.validateNumber}
          ],
          stockRentDate: [
            {required: true, message: '请选择可出租日期', trigger: 'change', type: 'date', validator: this.validateDate},
          ],
          surReason: [
            {required: true, message: '请输入解约原因', trigger: 'blur', type: 'string'}
          ],
          surReasonType: [
            {required: true, message: '请选择解约原因类型', trigger: 'change', validator: this.validateNumber}
          ]
        },
        formRules2: {
          goodsPayAmount: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          ]
        },
        formRules3: {
          goodsNewOld: [
            {required: true, message: '', trigger: 'change', validator: this.validateNumber}
          ],
          unit: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          ],
          goodsStatus: [
            {required: true, message: '', trigger: 'change', validator: this.validateNumber}
          ],
          goodsPayAmount: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          ]
        },
        formRules1: {
          meterPayType: [
            {required: true, message: '', trigger: 'change', validator: this.validateNumber}
          ],
          curMeterDisplay: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          ],
          preMeterDisplay:[
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}

          ]
        },
        n1: 0,
        loading: true,
        isShow: false,
        data1: [],
        data1Copy: [],
        data2: [],
        data3: [],
        validContractNum: false,
      }
    },
    computed:{
      surReasonsMap(){
        if(!this.data){
          return {}
        }
        let ret={}
        this.data.surReasons.forEach(ele=>{
          ret[ele.value+'']=ele.text
        })
        return ret
      }

    },
    methods: {
      showImg(src){
        this.imgSrc=src
        this.imgN++
      },
      getMeterAmount(item) {
        item.meterAmount = ''
        if(item.isSmartDevice===true){
          if (!item.curMeterDisplay && item.curMeterDisplay!==0) {
            return
          }
          let params = {
            contractFid: item.contractFid,
            meterType: item.meterType,
            curMeterDisplay: item.curMeterDisplay
          }
          calSurrenderMeterDeliveryAmount(params).then(res => {
            item.meterAmount = res.data.meterAmount
          }).catch(error => {
          })
        }
        else {
          if ((item.curMeterDisplay!==0 && !item.curMeterDisplay )|| (!item.preMeterDisplay && item.preMeterDisplay!==0)) {
            return
          }
          if(item.meterPayType===0){ //预付费
            item.meterAmount = ((Number(item.curMeterDisplay) - Number(item.preMeterDisplay)) * Number(item.unitPrice)).toFixed(2)
          }
          if(item.meterPayType===1){  //后付费
            if(Number(item.curMeterDisplay) < Number(item.preMeterDisplay)) {
              this.$Message.info('后付费：录入本次示数不能小于上次示数')
              return;
            }
            item.meterAmount = -((Number(item.curMeterDisplay) - Number(item.preMeterDisplay)) * Number(item.unitPrice)).toFixed(2)
          }
        }

      },
      cleanData() {
        this.data=null
        this.data1 = []
        this.data1Copy = []
        this.data2 = []
        this.data3 = []
        for (let i in this.$refs) {
          if (i ==='formData') {
            this.$refs[i].resetFields()
          }
          else {
            this.$refs[i][0] && this.$refs[i][0].resetFields()
          }
        }
      },
      formatDateTime: formatDateTime,
      closeModal() {
        this.$emit('done')
        this.isShow = false
      },
      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      surrenderdeliverysave() {

        this.data2.forEach(ele => {
          ele['deliveryType'] = 0
        })
        this.data3.forEach(ele => {
          ele['deliveryType'] = 1
        })
        let goodList = this.data2.concat(this.data3)
        goodList.forEach(ele => {
          ele['surrenderFid'] = this.data.surFid
          ele['contractFid'] = this.contractFid
          ele['stockFid'] = this.stockFid
        })
        this.data1Copy.forEach(ele => {
          ele['surrenderFid'] = this.data.surFid
          ele['stockFid'] = this.stockFid
        })
        let params = {
          surMeterDeliveryParamDtoList: this.data1Copy,
          surGoodsDeliveryParamDtoList: goodList,

        }
        surrenderdeliverysave(params).then(res => {
          if(this.data.surReasonType!==6){
            this.data.surReason=this.surReasonsMap[this.data.surReasonType]
          }

          this.n1++
          this.changeLoading()
        }).catch(error => {
          this.changeLoading()
        })
      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      handleSuccess(res, file) {
        let index = Number(res.data.type)
        this.data1Copy[index].meterPicName = file.name.length<=10?file.name:file.name.slice(0,10)+'...'
        this.data1Copy[index].meterPic = res.data.url
      },
      formatError() {
        this.$Message.info('请上传图片格式(jpg、png、jpeg)文件')
      },
      handleError() {

      },
      getSurrenderDecorationGoodsDeliveryInitInfo() {
        let params = {
          contractId: this.contractFid
        }
        getSurrenderDecorationGoodsDeliveryInitInfo(params).then(res => {
          if(!res.data){
            return
          }
          res.data.forEach(ele => {
            ele['goodsNewOld'] = 1
            ele['unit'] = 0
            ele['goodsStatus'] = 0
            ele['goodsPayAmount'] = 0
          })
          this.data3 = res.data
        }).catch(error => {
        })

      },
      getSurrenderGoodsDeliveryInitInfo() {
        let params = {
          contractId: this.contractFid
        }
        getSurrenderGoodsDeliveryInitInfo(params).then(res => {
          if(!res.data){
            return
          }
          res.data.forEach(ele => {
            ele['goodsPayAmount'] = 0
          })
          this.data2 = res.data
        }).catch(error => {
        })
      },
      getPersonalSurrenderMeterDeliveryInitInfo() {
        if (!this.contractFid) {
          return
        }
        let params = {
          contractId: this.contractFid
        }
        getPersonalSurrenderMeterDeliveryInitInfo(params).then(res => {
          if(!res.data){
            return
          }
          res.data.forEach(ele => {
            ele['meterPicName'] = ''
          })
          this.data1 = res.data
          this.data1Copy = deepClone(this.data1)
        }).catch(error => {
        })

      },
      getPersonalSurrenderInitInfo() {
        if (!this.contractFid) {
          return
        }
        let params = {
          contractId: this.contractFid
        }
        getPersonalSurrenderInitInfo(params).then(res => {
          if(!res.data){
            return
          }
          // res.data['stockStatus'] = ""
          // res.data['surReason'] = ''
          // res.data['surReasonType'] = ''
          this.data = res.data
          this.list2=res.data.certTypeList
        }).catch(error => {
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        //+表单校验
        let flag = true
        for (let i in this.$refs) {
          if (i === 'formData') {
            this.$refs[i].validate(bool => {
              !bool && (flag = false)
            })
          }
          else {
            this.$refs[i][0] && this.$refs[i][0].validate(bool => {
              !bool && (flag = false)
            })
          }
        }
        if (!flag) {
          this.$Message.info('请检查输入')
          this.changeLoading()
          return
        }
        // this.n1++
        //校验图片上传
        let fileValid = true
        for (let i = 0, len = this.data1.length; i < len; i++) {
          if (!this.data1[i].curMeterDisplay && this.data1[i].curMeterDisplay!==0) {
            if (!this.data1Copy[i].meterPic) {
              fileValid = false
              break
            }
          }
        }
        if (!fileValid) {
          this.$Message.info('请检查上传文件')
          this.changeLoading()
          return
        }

        //校验换租合同号

        if(this.data.surType===4||this.data.surType===11||this.data.surType===12||this.data.surType===13||this.data.surType===14){
          let params = {
            contractCode: this.data.changeContractCode,
            contractFid: this.contractFid
          }
          validChangeRentContract(params).then(res => {
            this.surrenderdeliverysave()
          }).catch(error => {
            // this.$Message.info('换租合同号校验失败')
            // this.data.changeContractCode=''
            this.changeLoading()
          })
        }
        else {
          this.surrenderdeliverysave()
        }
      },
      cancel() {
      }
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }
  }
</script>

<style scoped>

  .mb15form .ivu-form-item {
    margin-bottom: 15px;
  }

  .width250 {
    width: 350px;
  }

  .width150 {
    width: 200px;
  }

  .mb26 {
    margin-bottom: 26px;
  }

  .left, .right {
    display: inline-block;
    line-height: 2.5;
  }

  .left {
    width: 100px;
  }

  h4 {
    /*margin-top: 25px;*/
    margin-bottom: 10px;
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

  .inputwidth {
    width: 80px;
  }

  .ivu-select-dropdown {
    top: 32px !important;
  }


</style>
